export default "/images/85c1f24b68f2a5122e118721dc177b7a.avif";